var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import '@1js/office-start-style-utility/dist/styles/AppIcons.scss';
import '@1js/office-start-style-utility/dist/styles/DocumentIcons.scss';
import '@1js/office-start-style-utility/dist/styles/HomePage.scss';
import { useAIHubEnabled } from '@office-start/ai-hub-config-service';
import { AIHubSharedExecutionContextProviderAppContext, AIHubSharedExecutionContextProviderLazy as AIHubSharedExecutionContextProviderReactLazy, } from '@office-start/ai-hub-execution-context-provider-lazy';
import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { useStandaloneCopilotApp } from '@office-start/copilot-route-service';
import { prefetchEdgeworthData } from '@office-start/data-prefetch-service';
import { getIsMobile } from '@office-start/device-detection-utility';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useLogFloodgateActivity } from '@office-start/floodgate-service';
import HarmonyProvider from '@office-start/harmony-provider';
import { DataSecurityLevel, } from '@office-start/instrumentation-types';
import { prefetchNorthStar } from '@office-start/northstar-prefetch-service';
import { useCommonOfficeExperience, useOfficeExperienceRouter, } from '@office-start/office-experience-service';
import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import { OfficeHomeContextProvider } from '@office-start/office-home-context';
import { OfficeWorkload, } from '@office-start/officehome-types';
import { mark as markPerformance } from '@office-start/performance-service';
import { handlePauseScheduling, IDLE_VERYLOW_PRIORITY, IMMEDIATE_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { SearchPageBootstrapperProvider } from '@office-start/search-page-bootstrapper-service';
import { logError } from '@office-start/telemetry-service';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import createBrowserHistory from 'history/createBrowserHistory';
import withQuery from 'history-query-enhancer';
import queryString from 'query-string';
import React, { createRef, useEffect, useMemo, useRef } from 'react';
import { Router } from 'react-router-dom';
import { AIHubApp } from './Components/App/AIHubApp';
import { App } from './Components/App/App';
import { useInitializeIcons, useSetContentNode } from './hooks';
import { useWindowsAppLifecycleHandler } from './hooks/useWindowsAppLifecycleHandler';
import { getOfficeHomeAppRoutes } from './routing/getOfficeHomeAppRoutes';
import { getOfficeHomeAppRouteToPath } from './routing/getOfficeHomeAppRouteToPath';
import { MosAppsHostedAtRoot } from './routing/RoutePaths';
export var appbarConnectorService = AppbarConnectorService.getInstance();
/**
 * Ensure Lazy component is wrapped with ErrorBoundary
 * AIHubSharedExecutionContextProviderReactLazy doesn't have access to withLazyErrorBoundary
 */
var AIHubSharedExecutionContextProviderLazyErrorBoundary = withLazyErrorBoundary(AIHubSharedExecutionContextProviderReactLazy, 'AIHubSharedExecutionContextProvider', {
    schedulePriority: IMMEDIATE_PRIORITY,
});
export var OfficeHomeApp = function (_a) {
    var props = _a.props, commonContext = _a.commonContext;
    //This component renders only once as there is no state and props do not change.
    // Hence not adding any logic to call the below function once.
    markPerformance("React_Render_Ohome_Start" /* KnownPerformanceMarks.ReactRenderOhomeStart */, "Appbar_Connector_Service_Start" /* KnownPerformanceMarks.AppbarConnectorServiceStart */, DataSecurityLevel.Security, {
        AppUrl: window.location.pathname,
    });
    var history = withQuery(queryString)(createBrowserHistory());
    useEffect(function () {
        var _a;
        (_a = window === null || window === void 0 ? void 0 : window.logPWABootPerf) === null || _a === void 0 ? void 0 : _a.call(window, 'OfficeHomeAppInitBegin');
    }, []);
    return (React.createElement(Router, { history: history },
        React.createElement(OfficeHomeContextProvider, { workload: commonContext.workload, isStandaloneCopilot: false },
            React.createElement(OfficeHomeAppSetup, { props: props, commonContext: commonContext }))));
};
var scrollContentRef = createRef();
/**
 * Setup component context in this 'setup' component, so that it is only done once.
 * Do not re-render components that re-initialize context.
 * @param props OfficeExperienceContext
 * @returns
 */
var OfficeHomeAppSetup = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var props = _a.props, commonContext = _a.commonContext;
    var floodgateActivity = useLogFloodgateActivity();
    React.useEffect(function () {
        var timer = setTimeout(function () {
            floodgateActivity('AppUsageTimeNPS');
            clearTimeout(timer);
        }, 5 * 60 * 1000); // Show NPS campaign after 5 minutes of usage.
        return function () { return clearTimeout(timer); };
    }, [floodgateActivity]);
    var dataPrefetched = useRef(false);
    var userEntitlements = useUserEntitlements().data;
    var isStandaloneCopilotPage = useStandaloneCopilotApp();
    var featureGates = (_c = (_b = useFeatureGates()) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.result;
    var isCommercialUser = ((_d = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _d === void 0 ? void 0 : _d.isCommercialUser) || false;
    if (!dataPrefetched.current) {
        dataPrefetched.current = true;
        !isStandaloneCopilotPage &&
            !appbarConnectorService.getIsCopilotChatExperience() &&
            prefetchNorthStar(isCommercialUser);
        appbarConnectorService.getIsCopilotChatExperience() &&
            scheduleWork(function () { return prefetchNorthStar(isCommercialUser); }, IDLE_VERYLOW_PRIORITY, 'prefetchNorthStar') &&
            scheduleWork(function () { return prefetchEdgeworthData(isStandaloneCopilotPage); }, IDLE_VERYLOW_PRIORITY, 'prefetchEdgeworthData');
        !appbarConnectorService.getIsCopilotChatExperience() &&
            prefetchEdgeworthData(isStandaloneCopilotPage);
        var pauseSchedulerForMosApp = (_f = (_e = featureGates === null || featureGates === void 0 ? void 0 : featureGates.pauseSchedulerGates) === null || _e === void 0 ? void 0 : _e.pauseSchedulerInOfficeHomeAppEnabled) !== null && _f !== void 0 ? _f : false;
        if (pauseSchedulerForMosApp &&
            ((!appbarConnectorService.tileChanged &&
                appbarConnectorService.getIsCopilotChatExperience()) ||
                isStandaloneCopilotPage)) {
            handlePauseScheduling();
        }
    }
    var setContentNode = useSetContentNode();
    var workload = commonContext.workload;
    useEffect(function () {
        if (workload === OfficeWorkload.Hwa) {
            var hideSplashScreen = function () { return __awaiter(void 0, void 0, void 0, function () {
                var hideHwaSplashScreen, error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, import('@office-start/hwa-native-bridge-service')];
                        case 1:
                            hideHwaSplashScreen = (_b.sent()).hideHwaSplashScreen;
                            hideHwaSplashScreen();
                            (_a = window === null || window === void 0 ? void 0 : window.logPWABootPerf) === null || _a === void 0 ? void 0 : _a.call(window, 'HideSplashScreen');
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            logError({
                                eventName: 'HideSplashScreenError',
                                message: error_1 || 'Error hiding splash screen',
                            });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            hideSplashScreen();
        }
    }, [workload]);
    useWindowsAppLifecycleHandler(workload);
    var rootPath = props.rootPath || '';
    var isAIHubEnabled = useAIHubEnabled(rootPath);
    var isMobile = getIsMobile();
    var isStandaloneCopilotApp = (_g = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _g === void 0 ? void 0 : _g.isStandaloneCopilotApp;
    var officeHomeAppRouteConfig = getOfficeHomeAppRoutes(setContentNode, isStandaloneCopilotApp, scrollContentRef, rootPath);
    var officeHomeAppRoutes = useMemo(function () { return officeHomeAppRouteConfig.map(function (route) { return route.route; }); }, [officeHomeAppRouteConfig]);
    var routerCallbacks = useOfficeExperienceRouter(officeHomeAppRoutes, getOfficeHomeAppRouteToPath(rootPath), MosAppsHostedAtRoot);
    // Ensure icons are registered before rendering
    // Components won't necessarily re-render all the way down if icons are registered after
    // rendering.
    var shouldInitializeIconsWithDelay = appbarConnectorService.getIsCopilotChatExperience();
    useInitializeIcons(isStandaloneCopilotPage, shouldInitializeIconsWithDelay);
    // Initialize the router
    useCommonOfficeExperience(props, routerCallbacks, commonContext, true);
    var executedCopilotFirstFlow = useRef(false);
    useEffect(function () {
        var _a;
        if (!executedCopilotFirstFlow.current &&
            workload === OfficeWorkload.Hwa &&
            isCommercialUser &&
            ((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.pwaCopilotFirstGates) === null || _a === void 0 ? void 0 : _a.pwaCopilotFirstEnabled)) {
            // Navigate to copilot page (chat route)
            routerCallbacks.navigateTo({ route: 'Chat' });
            executedCopilotFirstFlow.current = true;
        }
    }, [
        (_h = featureGates === null || featureGates === void 0 ? void 0 : featureGates.pwaCopilotFirstGates) === null || _h === void 0 ? void 0 : _h.pwaCopilotFirstEnabled,
        isCommercialUser,
        routerCallbacks,
        workload,
    ]);
    // AppDate needed for later shared execution context creation,
    // This provider only cache the value for later use.  Thus should be very light weight
    // The consume of this data is
    // <SetupAIHubSharedExecutionContextProvider> then consume the value and right on top of
    // the Router component <OfficeHomeAppRouteComponent>
    // As Router is where the page dispatch happen.
    // In addition, this allow us to NOT setup SED in the  Router when isStandaloneCopilotApp is true
    var sharedExecutionContextProviderAppContextValue = React.useMemo(function () { return ({
        officeExperienceContext: props,
        workload: workload,
        initialLoadAIHubSharedContext: isAIHubEnabled,
        AIHubSharedExecutionContextProviderLazyErrorBoundary: AIHubSharedExecutionContextProviderLazyErrorBoundary,
    }); }, [props, workload, isAIHubEnabled]);
    var officeApp = useMemo(function () {
        return isAIHubEnabled ? (React.createElement(AIHubApp, __assign({}, props, { scrollContentRef: scrollContentRef, rootPath: rootPath, officeHomeAppRouteConfig: officeHomeAppRouteConfig, isMobile: isMobile }))) : (React.createElement(SearchPageBootstrapperProvider, null,
            React.createElement(App, __assign({}, props, { scrollContentRef: scrollContentRef, rootPath: rootPath, officeHomeAppRouteConfig: officeHomeAppRouteConfig, isMobile: isMobile }))));
    }, [isAIHubEnabled, isMobile, officeHomeAppRouteConfig, props, rootPath]);
    return (React.createElement(AIHubSharedExecutionContextProviderAppContext.Provider, { value: sharedExecutionContextProviderAppContextValue },
        React.createElement(HarmonyProvider, null, officeApp)));
};
//# sourceMappingURL=OfficeHomeApp.js.map